export const ROBLOX_CAMPAIGN_TYPE = 'roblox-exploitation'
export const ROBLOX_CAMPAIGN_NAME = 'Roblox Exploitation'

